import request from '@/router/axios'
// 菜单树形
export function menuTree(query) {
    return request({
      url: '/articleMenu/tree',
      method: 'post',
      params: query
    })
  }
  // 菜单增加
export function menuInsert(query) {
  return request({
    url: '/articleContent/insert',
    method: 'post',
    params: query
  })
}
  // 菜单修改
  export function menuUpdate(query) {
    return request({
      url: '/articleContent/update',
      method: 'post',
      params: query
    })
  }
  // 菜单列表
  export function menuList(query) {
    return request({
      url: '/articleContent/',
      method: 'post',
      params: query
    })
  }
   // 菜单删除
   export function menuDelete(query) {
    return request({
      url: '/articleContent/del',
      method: 'post',
      params: query
    })
  }
  // 菜单删除
  export function menuinfo(query) {
    return request({
      url: '/articleContent/info',
      method: 'post',
      params: query
    })
  }
